import { render, staticRenderFns } from "./edit-post.vue?vue&type=template&id=74d45b44&scoped=true&"
import script from "./edit-post.vue?vue&type=script&lang=js&"
export * from "./edit-post.vue?vue&type=script&lang=js&"
import style0 from "./edit-post.vue?vue&type=style&index=0&id=74d45b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d45b44",
  null
  
)

export default component.exports